import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
  useState
} from 'react'
import { TAdditionalValue } from '../types'
import { ability, ACTIONS, SUBJECTS } from '../../Permission'

type ContextProps = {
  state: {
    selectedAdditionalValue?: TAdditionalValue
    isAbleToManage: boolean
  }
  actions: {
    setSelectedAdditionalValue: (item?: TAdditionalValue) => void
  }
}

const AdditionalValuesContext = createContext<ContextProps>({
  state: {} as ContextProps['state'],
  actions: {} as ContextProps['actions']
})

const AdditionalValuesContextProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [selectedAdditionalValue, setSelectedAdditionalValue] = useState<
    TAdditionalValue | undefined
  >(undefined)

  const isAbleToManage = ability.can(ACTIONS.MANAGE, SUBJECTS.ADDITIONAL_VALUES)
  const context = useMemo(
    () => ({
      state: {
        selectedAdditionalValue,
        isAbleToManage
      },
      actions: {
        setSelectedAdditionalValue
      }
    }),
    [selectedAdditionalValue, isAbleToManage]
  )

  return (
    <AdditionalValuesContext.Provider value={context}>
      {children}
    </AdditionalValuesContext.Provider>
  )
}

export const useAdditionalValuesContext = () =>
  useContext(AdditionalValuesContext)

export default AdditionalValuesContextProvider
